<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="pink--text">Info</span>
        <v-spacer></v-spacer> <v-icon class="red--text" @click="$emit('closeInfo')">mdi-close</v-icon></v-card-title>
      <v-form @submit.prevent="submitForm" class="pa-2">
        <v-row>
          <v-col cols="12" md="3">
            <!-- Age list Need update From Back End -->
            <v-autocomplete v-model="partnerpreferenceList.min_age" :items="dropDownList?.agelist" label="Min age"></v-autocomplete>
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete v-model="partnerpreferenceList.max_age"  :items="dropDownList?.agelist" label="Max age"></v-autocomplete>
          </v-col>
           <v-col cols="12" md="3">
            <v-autocomplete v-model="partnerpreferenceList.min_height" :items="LookupArr(dropDownList?.heightList)" item-text="text" item-value="value" label="Min Height"></v-autocomplete>
          </v-col>
           <v-col cols="12" md="3">
            <v-autocomplete v-model="partnerpreferenceList.max_height" :items="LookupArr(dropDownList?.heightList)" item-text="text" item-value="value" label="Max Height"></v-autocomplete>
          </v-col>
           <v-col cols="12" md="3">
            <v-autocomplete v-model="partnerpreferenceList.diet" multiple :items="LookupArr(dropDownList?.dietList)" item-text="text" item-value="value" label="Diet"></v-autocomplete>
          </v-col>
           <v-col cols="12" md="3">
            <v-autocomplete v-model="partnerpreferenceList.motherTongue" multiple :items="LookupArr(dropDownList?.languages)" item-text="text" item-value="value" label="Mother Tongue"></v-autocomplete>
          </v-col> <v-col cols="12" md="3">
            <v-autocomplete v-model="partnerpreferenceList.martialStatus" multiple :items="LookupArr(dropDownList?.martialStatusList)" item-text="text" item-value="value" label="Martial Status"></v-autocomplete>
          </v-col>
          <v-col cols="12" md="12" class="d-flex justify-end">
            <v-btn type="submit" class="primary elevation-0"> Submit</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      Indicator: "userinfo",
    };
  },
  props: {
    partnerpreference: {}, partnerpreferenceList: [], dropDownList: {}
  },
methods:{
  submitForm() {


this.$emit("userinfo", this.Indicator)
// Handle form submission logic here, e.g., send data to an API or update the state
},
}


};
</script>